export enum BillingFrequency {
    "", "Maandelijks", "Jaarlijks"
}